import React from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import * as ReactDOMServer from "react-dom/server";
import { useDispatch, useSelector } from "react-redux";
import { TRIP_STATUS } from "../../Data/TripConstants";
import getTripPointsOnMap from "../../../../Utils/getTripPointsOnMap";
import { updateTrips } from "../../../../Redux/Slices/trips.slice";
import EditIcon from "../../../../Common/Svgs/EditIcon";

const getDeviationStopMarker = (stopNumber) =>
  L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="relative  -mt-[45px] -ml-[15px]">
        <svg width="44" height="54" viewBox="0 0 44 54">
          <path
            d="M17 40L22 47L27 40H15Z"
            fill="#525252"
            stroke="#525252"
            strokeWidth="2"
          />

          <circle
            cx="22"
            cy="24"
            r="16"
            fill="#DFDFDF"
            stroke="#525252"
            strokeWidth="2"
          />
        </svg>

        <div
          className="
            absolute
            top-[14px]
            left-[18px]
            font-poppins font-medium text-base leading-none text-dark-gray
          "
        >
          {stopNumber}
        </div>

        <div
          className="
    absolute
    top-1
    left-7
    group
  "
        >
          <div
            className="
      w-4
      h-4
      rounded-full
      bg-[#525252]
      text-white
      text-[10px]
      flex
      items-center
      justify-center
      cursor-pointer
    "
          >
            i
          </div>

          <div
            className="
      hidden
      group-hover:flex
      flex-col
      items-center
      absolute
      top-[24px]
      left-1/2
      -translate-x-1/2
      z-[99999]
      pointer-events-none
    "
          >
            <div
              className="
      w-3
      h-3
      bg-[#4A4A4A]
      rotate-45
      mb-[-6px]
      z-10
    "
            />

            {/* Tooltip */}
            <div
              className="
      bg-dark-gray
      text-background
      text-[10px]
      px-3
      py-2
      rounded
      whitespace-nowrap
      text-center
      font-aileron font-normal leading-none
    "
            >
              No collection recorded at the
              <br />
              registered location
            </div>
          </div>
        </div>
      </div>,
    ),
  });

const getNewLocationMarker = (stopNumber, dispatch) =>
  L.divIcon({
    iconSize: [190, 44],
    iconAnchor: [20, 22],

    html: ReactDOMServer.renderToString(
      <div
        className="relative z-[99999]"
        onClick={() => {
          console.log("open");
          dispatch(
            updateTrips({
              key: "reviewLocationModal",
              value: {
                visible: true,
                // data: { step: trikeRepairSteps.REQUEST_ACCEPTED },
              },
            }),
          );
        }}
      >
        <div
          className="
          flex
          items-center
          justify-around
          rounded-full
          bg-[#D34F33]
          text-white
          overflow-hidden
          shadow-md
          gap-x-1
          p-2
        "
        >
          <div
            className="
            font-poppins font-medium text-base leading-none text-[#FCFCFC]
          "
          >
            {stopNumber}
          </div>

          <div className="font-poppins font-medium text-[10px] leading-none text-[#FCFCFC]">
            New location detected
          </div>
          {/* <img src="/assets/icons/edit.svg" alt="edit" /> */}
          <EditIcon size={13} strokeWidth={2} />
        </div>
        <div
          className="
        absolute
        left-4
        -bottom-[3px]
        w-4
        h-3
        bg-[#D34F33]
        rotate-45
      "
        />
      </div>,
    ),
  });

const THRESHOLD = 0.001;

const StopCoordinates = ({ stopCoordinates, overallSummaryForTrip }) => {
  const dispatch = useDispatch();

  const recordedCoordinates =
    overallSummaryForTrip?.stopActivities
      ?.slice(0, -1)
      ?.map((stop) => [
        stop.recordedLat != null ? Number(stop.recordedLat) : null,
        stop.recordedLong != null ? Number(stop.recordedLong) : null,
      ]) || [];

  const lastVisitedStop = recordedCoordinates
    .slice(1, -1)
    .reduce((last, coord, index) => {
      if (coord && coord[0] != null && coord[1] != null) {
        return index;
      }

      return last;
    }, -1);

  const { currentTrip } = useSelector((state) => state.trips);

  return stopCoordinates?.map((item, index) => {
    const [lat, long] = recordedCoordinates[index] ?? [];

    const activityCount =
      overallSummaryForTrip?.stopActivities?.[index]?.activities?.length;

    const recordedTime =
      overallSummaryForTrip?.stopActivities?.[index]?.recordedTime;

    const isDeviatedStop =
      lat != null &&
      long != null &&
      Math.abs(item[0] - lat) + Math.abs(item[1] - long) > THRESHOLD;

    const isUpcoming = currentTrip?.statusId === TRIP_STATUS.UPCOMING;

    return (
      <>
        <Marker
          position={item}
          icon={
            isDeviatedStop && !isUpcoming
              ? getDeviationStopMarker(index)
              : getTripPointsOnMap(
                  index,
                  currentTrip?.stops?.length,
                  currentTrip?.statusId,
                  lastVisitedStop,
                  recordedTime,
                )
          }
        />

        {isDeviatedStop && !isUpcoming && (
          <Marker
            eventHandlers={{
              click: () => {
                dispatch(
                  updateTrips({
                    key: "reviewLocationModal",
                    value: {
                      visible: true,
                      originalPosition: {
                        lat: item[0],
                        long: item[1],
                      },
                      recordedPosition: {
                        lat,
                        long,
                      },
                      activityCount,
                      recordedTime,
                    },
                  }),
                );
              },
            }}
            position={[lat, long]}
            icon={getNewLocationMarker(index, dispatch)}
          />
        )}
      </>
    );
  });
};

export default StopCoordinates;
